import type { FC } from 'react';
import { BlockBody, handleReplaceMentionValues } from '@ContractBuilder/modules/block';
import { sanitizeHtml } from '@helpers/sanitizeHtml';
import type { DynamoDBResourceBlock } from '@root/@types/database';
import type { BlockMentionValues } from '@root/@types/types';
import { isTemplatePath } from '@utils/app-paths';

import { blockContentClasses, blockTitleClasses } from '../constants/classes';

interface BlockViewProps {
  block: DynamoDBResourceBlock;
  className?: string;
  disableMentionHighlight?: boolean;
  hasBeenMovedByRenewal?: boolean;
  isEditing?: boolean;
  isHighlighted?: boolean;
  isInCreateMode?: boolean;
  isPdfRender?: boolean;
  isVisible?: boolean;
  mentionValues: BlockMentionValues;
  showEndorsementDiff?: boolean;
}

export const BlockContent: FC<BlockViewProps> = ({
  block,
  className,
  disableMentionHighlight,
  hasBeenMovedByRenewal = false,
  isEditing,
  isHighlighted,
  isInCreateMode,
  isPdfRender,
  isVisible,
  mentionValues,
  showEndorsementDiff,
}) => {
  const isTemplate = isTemplatePath();

  const { title, content = '', order, type, id, name, canEdit } = block;

  const isLockedFromEditing = !isTemplate && !canEdit;
  const isTwoColLayout = ['mrc-heading', 'clause-heading'].includes(type);
  const disableMentions = isTemplate;

  const processedContent = isPdfRender ? content : handleReplaceMentionValues(block, mentionValues);

  return (
    <BlockBody
      className={className}
      id={id}
      name={name}
      order={order}
      // flags
      disableMentionHighlight={disableMentionHighlight}
      hasBeenMovedByRenewal={hasBeenMovedByRenewal}
      isPDFRender={isPdfRender}
      isEditing={isEditing}
      isHighlighted={isHighlighted}
      isVisible={isVisible}
      isInCreateMode={isInCreateMode}
      isLockedFromEditing={isLockedFromEditing}
      showEndorsementDiff={showEndorsementDiff}
    >
      {isTwoColLayout && <div className={blockTitleClasses({ type, pdf: isPdfRender && type })}>{title}</div>}

      <div
        dangerouslySetInnerHTML={{ __html: isVisible ? sanitizeHtml(processedContent ?? content) : '' }}
        className={blockContentClasses({
          type,
          pdf: isPdfRender && type,
          disableMentions,
        })}
      />
    </BlockBody>
  );
};
